import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Popupform from '../../Components/Popupform/Popupform';
import CollageTable from "./CollageTable";
import axios from "axios";
import config from "../../config/config";
import { FiHome, FiChevronRight } from 'react-icons/fi';

const Collegemainpage = () => {
    const urlid = useParams();
    const id = urlid.id;
    const [singlepage, setSinglepage] = useState(null);

    useEffect(() => {
        const fetchSingleCoursepage = async () => {
            try {
                const response = await axios.get(
                    `${config.API_BASE_URL}/api/admin/getSingle_collegespage/${id}`
                );
                setSinglepage(response.data);
            } catch (error) {
                console.error("Error fetching course data:", error);
            }
        };
        fetchSingleCoursepage();
    }, [id]);

    return (
        <div className="bg-white">
            {/* Banner Section */}
            <div className="bg-brand-orange pb-20 pt-[160px] lg:pt-[220px] px-4 text-center relative overflow-hidden -mt-[130px] lg:-mt-[180px]">
                <div className="absolute inset-0 bg-black/10"></div>
                <div className="relative z-10 max-w-4xl mx-auto">
                    <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 animate-fade-in-up">
                        {singlepage?.bannerHeading || "Loading..."}
                    </h2>
                    <p className="text-white text-lg opacity-90 leading-relaxed max-w-2xl mx-auto">
                        {singlepage?.bannerText}
                    </p>
                </div>
            </div>

            {/* Breadcrumb Navigation */}
            <div className="bg-gray-50 border-b border-gray-100 py-3">
                <div className="container mx-auto px-4">
                    <div className="flex items-center text-sm text-gray-500">
                        <Link to="/" className="hover:text-brand-orange transition flex items-center">
                            <FiHome className="mr-1" /> Home
                        </Link>
                        <FiChevronRight className="mx-2" />
                        <span className="font-semibold text-brand-orange">
                            {singlepage?.pageName} Colleges
                        </span>
                    </div>
                    <h1 className="text-2xl font-bold text-gray-800 mt-4">{singlepage?.title}</h1>
                </div>
            </div>

            {/* Table Section */}
            <div className="container mx-auto px-4 py-16">
                <div className="text-center mb-12 max-w-3xl mx-auto">
                    <h2 className="text-3xl font-bold text-gray-800 mb-4">{singlepage?.tableHeading}</h2>
                    <p className="text-gray-500 leading-relaxed">{singlepage?.tableText}</p>
                    <div className="w-24 h-1 bg-brand-orange mx-auto mt-6 rounded-full"></div>
                </div>

                <CollageTable courseName={singlepage?.pageName} />
            </div>

            {/* Info Section 1 */}
            <div className="bg-gray-50 py-20">
                <div className="container mx-auto px-4">
                    <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-gray-100 text-center max-w-4xl mx-auto">
                        <h2 className="text-3xl font-bold text-gray-800 mb-4">{singlepage?.heading}</h2>
                        <p className="text-gray-500 leading-relaxed text-lg">{singlepage?.subHeading}</p>
                    </div>
                </div>
            </div>

            {/* Info Section 2 (Image + Text) */}
            <div className="container mx-auto px-4 py-20">
                <div className="flex flex-col lg:flex-row items-center gap-12">
                    <div className="lg:w-1/2">
                        <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white transform hover:rotate-1 transition duration-500">
                            <img
                                src={`${config.API_BASE_URL}/uploads/${singlepage?.image}`}
                                alt={singlepage?.bannerHeading}
                                className="w-full h-auto object-cover"
                            />
                        </div>
                    </div>
                    <div className="lg:w-1/2">
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6 leading-tight">
                            {singlepage?.imgHeading}
                        </h2>
                        <p className="text-gray-600 mb-4 leading-relaxed text-lg">
                            {singlepage?.imgpara1}
                        </p>
                        <p className="text-gray-600 leading-relaxed text-lg">
                            {singlepage?.imgpara2}
                        </p>
                    </div>
                </div>
            </div>

            {/* Final CTA / Popup Section */}
            <div className="bg-brand-orange py-20 px-4 text-center mt-10">
                <div className="max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-2xl">
                    <div className="mb-8">
                        <h2 className="text-3xl font-bold text-gray-800 mb-2">Not sure where to start?</h2>
                        <p className="text-gray-500">Get expert counseling and find your dream college today.</p>
                    </div>
                    <div className="popup-wrapper-embedded">
                        <Popupform />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Collegemainpage;
